import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "../lib/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/insights", label: "Insights" },
  { to: "/watch", label: "Watch" },
  { to: "/book-a-call", label: "Book a Call" },
  { to: "/sell-your-land", label: "Sell Your Land" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl transition-all duration-300 ${
        scrolled ? "bg-[#0B0F0E]/90 border-b border-[#F4EFE6]/10" : "bg-[#0B0F0E]/70"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-24 md:h-28">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-4">
          <img
            src={SITE.logo}
            alt="Upsurge Strategic Land"
            className="h-16 md:h-20 w-16 md:w-20 object-contain"
            style={{ filter: "brightness(0) saturate(100%) invert(72%) sepia(36%) saturate(490%) hue-rotate(8deg) brightness(92%) contrast(86%)" }}
          />
          <div className="leading-tight">
            <div className="font-display text-[#F4EFE6] text-2xl md:text-3xl tracking-tight">UPSURGE</div>
            <div className="text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-[#C9A24B] font-semibold mt-0.5">Strategic Land</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `link-underline text-[12px] tracking-[0.18em] uppercase font-semibold ${isActive ? "text-[#C9A24B] link-active" : "text-[#F4EFE6]/85 hover:text-[#C9A24B]"}`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Link to="/sell-your-land" data-testid="nav-cta-sell-land" className="usl-btn">Get Appraisal</Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#C9A24B] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#F4EFE6]/10 bg-[#0B0F0E]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="text-[#F4EFE6] text-sm uppercase tracking-[0.2em] font-semibold py-2 hover:text-[#C9A24B]"
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/sell-your-land" onClick={() => setOpen(false)} data-testid="mobile-cta-sell-land" className="usl-btn justify-center">Get Appraisal</Link>
          </div>
        </div>
      )}
    </header>
  );
}
